import Login from "@/components/pages/login/Login";
import getStaticPropsWrapper from "@/lib/utils/getStaticPropsWrapper";

export default Login;

export const getStaticProps = getStaticPropsWrapper()
